import create from 'zustand';
import { getPaypalConfig } from '@/apis';
import { type ReactPayPalScriptOptions } from '@paypal/react-paypal-js';
import { type InferActionRes } from '@/types/infer';
import { useCurrencyConfig } from './useCurrency';

type PaypalClientConfig = InferActionRes<typeof getPaypalConfig>;

export interface PaypalStore {
  clientId?: string;
  clientSecret?: string;
  options: ReactPayPalScriptOptions;

  getClientConfig: () => Promise<PaypalClientConfig>;
}

export const usePaypal = create<PaypalStore>((set, get) => ({
  options: {
    clientId: '',
    components: ['buttons', 'applepay'],
    enableFunding: ['card', 'paylater', 'credit', 'paypal'],
    disableFunding: [
      'bancontact',
      'blik',
      'eps',
      'giropay',
      'ideal',
      'mercadopago',
      'mybank',
      'p24',
      'sepa',
      'sofort',
      'venmo',
    ],
    // locale: 'en_US',
    currency: useCurrencyConfig.getState().currency,
    dataPageType: 'checkout',
  },

  async getClientConfig() {
    try {
      const res = await getPaypalConfig({}, undefined, { reLogin: false }).then(
        (res) => (res as any).data,
      );
      const { options } = get();
      set({
        clientId: res.client_id,
        clientSecret: res.client_secret,
        options: {
          ...options,
          clientId: res.client_id!,
        },
      });
      return res;
    } catch {
      return null;
    }
  },
}));
